import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';
import { appendClassNames } from '../../../../lib/bemUtils/classname';
import { DownloadAttachmentSnippet } from './DownloadAttachmentSnippet';

type DownloadContainer = PropsWithChildren<DivProps & { snippet?: string; title?: string }>;
export function DownloadContainer({ children, className, snippet, title, ...props }: DownloadContainer) {
  return (
    <div className={appendClassNames('download', className)} {...props}>
      <figure className="download__figure">{children}</figure>
      {snippet && title && <DownloadAttachmentSnippet snippet={snippet} title={title} />}
    </div>
  );
}
